import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import emailjs from 'emailjs-com';
import './DeviceOptOutForm.css';

const DeviceOptOutForm = () => {
    const location = useLocation();
    const [formData, setFormData] = useState({
        deviceId: '',
        email: '',
        reason: ''
    });
    const [status, setStatus] = useState(''); // 'submitting', 'success', 'error'

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const deviceIdParam = queryParams.get('deviceId');
        if (deviceIdParam) {
            setFormData(prev => ({ ...prev, deviceId: deviceIdParam }));
        }
    }, [location]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setStatus('submitting');

        // Prepare the data for the email template
        // We map our fields to the 'feedback' field in the template since likely that's what is displayed
        const templateParams = {
            name: 'Device Opt-Out Request',
            email: formData.email || 'No email provided',
            feedback: `Device ID: ${formData.deviceId}\nReason: ${formData.reason || 'No reason provided'}`,
            about: 'Device Opt-Out',
            commentType: 'Opt-Out Request',
            // Fill other required fields with placeholders if necessary to satisfy the template
            nativeLanguage: 'N/A',
            learningLanguage: 'N/A',
            recommend: 'N/A',
            experience: 'N/A',
            device: 'N/A'
        };

        emailjs
            .send(
                'service_hhqtx2m',
                'template_k3ngonf',
                templateParams,
                'aKhEL7jx_LGN9Fo9y'
            )
            .then(
                (result) => {
                    console.log('Opt-out request sent:', result.text);
                    setStatus('success');
                    setFormData({ deviceId: '', email: '', reason: '' });
                },
                (error) => {
                    console.error('Error:', error.text);
                    setStatus('error');
                }
            );
    };

    return (
        <div className="opt-out-form-container">
            <h3>Request Device ID Deletion</h3>
            <p>If you wish to opt-out of Device ID collection and have your Device ID removed from our system, please fill out the form below. Note that this may affect your ability to use School Codes.</p>

            {status === 'success' ? (
                <div className="success-message">
                    <p>Your request has been submitted successfully.</p>
                </div>
            ) : (
                <form className="opt-out-form" onSubmit={handleSubmit}>
                    <label htmlFor="deviceId">Device ID (Required):</label>
                    <input
                        type="text"
                        id="deviceId"
                        name="deviceId"
                        value={formData.deviceId}
                        onChange={handleChange}
                        required
                        placeholder="Enter your Device ID"
                    />

                    <label htmlFor="email">Email (Optional):</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="For confirmation"
                    />

                    <label htmlFor="reason">Reason (Optional):</label>
                    <textarea
                        id="reason"
                        name="reason"
                        value={formData.reason}
                        onChange={handleChange}
                        placeholder="Why do you want to opt-out?"
                    ></textarea>

                    {status === 'error' && <p className="error-message">An error occurred. Please try again.</p>}

                    <button type="submit" disabled={status === 'submitting'}>
                        {status === 'submitting' ? <div className="spinner"></div> : 'Submit Opt-Out Request'}
                    </button>
                </form>
            )}
        </div>
    );
};

export default DeviceOptOutForm;
